
    export class HTMLScriptElementTracker extends HTMLScriptElement {
        public onloadDone: boolean = false;
        public onreadystatechange: (ev: Event) => any;
        public readyState: string;
    }

    export class DeferredLoader {

        public static InjectScript(scriptUrl: string, onLoadCallback: Function = null): HTMLScriptElementTracker {
            const element = <HTMLScriptElementTracker>document.createElement("script");
            element.src = scriptUrl;
            element.async = true;

            if (onLoadCallback !== null) {
                element.onloadDone = false;
                element.onload = function () {
                    if (!element.onloadDone) {
                        element.onloadDone = true;
                        onLoadCallback();
                    }
                };
                element.onreadystatechange = function () {
                    if (("loaded" === element.readyState || "complete" === element.readyState) && !element.onloadDone) {
                        element.onloadDone = true;
                        onLoadCallback();
                    }
                }
            }

            document.body.appendChild(element);
            return element;
        }
    }
